import { setDarkModeState, getDarkModeState } from './cookieService';

class DarkModeService {
  constructor() {
    this.darkMode = false;
    this.systemPrefersDark = false;
  }

  // Detect system preference
  detectSystemPreference() {
    if (window.matchMedia) {
      this.systemPrefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    }
    return this.systemPrefersDark;
  }

  // Initialize dark mode from cookie or system preference
  initialize() {
    const savedPreference = getDarkModeState();
    
    if (savedPreference !== null) {
      // User has a saved preference
      this.darkMode = savedPreference;
    } else {
      // No saved preference, use system preference
      this.darkMode = this.detectSystemPreference();
    }
    
    this.applyDarkMode();
    
    // Listen for system preference changes
    if (window.matchMedia) {
      window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (e) => {
        // Only apply system preference if user hasn't set a manual preference
        const savedPreference = getDarkModeState();
        if (savedPreference === null) {
          this.darkMode = e.matches;
          this.applyDarkMode();
        }
      });
    }
    
    return this.darkMode;
  }

  // Toggle dark mode
  toggle() {
    this.darkMode = !this.darkMode;
    setDarkModeState({ isDarkMode: this.darkMode });
    this.applyDarkMode();
    return this.darkMode;
  }

  // Apply or remove dark mode class
  applyDarkMode() {
    if (this.darkMode) {
      document.documentElement.classList.add('dark-mode');
    } else {
      document.documentElement.classList.remove('dark-mode');
    }
  }

  // Get current dark mode state
  isDarkMode() {
    // Check the actual DOM state to ensure sync
    const hasDarkModeClass = document.documentElement.classList.contains('dark-mode');
    // Also check cookie as fallback
    const savedPreference = getDarkModeState();
    if (savedPreference !== null) {
      this.darkMode = savedPreference;
    } else {
      this.darkMode = hasDarkModeClass;
    }
    return this.darkMode;
  }
}

// Export a singleton instance
export default new DarkModeService();

